export const isSendButtonDisabled = errors => {
  const keys = Object.keys(errors);
  let disabled = false;
  keys.forEach(key => {
    if (errors[key].isPristine || errors[key].hasError) {
      disabled = true;
    }
  });
  return disabled;
};